import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityStateUpdater from 'component/EntityStateUpdater';

import FormInput from 'components/forms/FormInput';

import Loader from 'components/layout/Loader';

import Entity from 'components/Entity';
import Data from 'components/Data';
import Modal from 'components/Modal';

import { entityMetaMapping } from 'js/constants';

class OrderEnterBankData extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entity: null,
      entityLoaded: false,
    };

    this.entity = new Entity();
    this.entity.setData({ reference: '--' });

    if (
      props.meta[entityMetaMapping.orderActionPaymentInstructions] !== undefined &&
      !props.meta[entityMetaMapping.orderActionPaymentInstructions].pending
    ) {
      this.entity.setMeta(props.meta, entityMetaMapping.orderActionPaymentInstructions);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      meta,
      formStatus,
      close,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      close();
      doNotify(1, messages.bank_data_updated);
    }

    if (
      meta[entityMetaMapping.orderActionPaymentInstructions] !== undefined &&
      !meta[entityMetaMapping.orderActionPaymentInstructions].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.orderActionPaymentInstructions);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          if (this.state.entity.isValid) {
            this.props.onSubmit(this.props.user.username, {
              financial: {
                bankData: {
                  accountHolder: this.state.entity.getAccountHolder(),
                  iban: this.state.entity.getIban(),
                  swiftBic: this.state.entity.getSwiftBic(),
                  bankName: this.state.entity.getBankName(),
                  bankLocation: this.state.entity.getBankLocation(),
                },
              },
            });
          }
        }
      );
    }, 150);

    return false;
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      order,
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    const disabled = formStatus.pending;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.enter_bank_data}{' '}
            <span class="small hint-text">
              {messages.order} {order.id}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="orderActionPaymentInstructions" />

          {entityLoaded ? (
            <form type="put" onSubmit={this.onSubmit}>
              <div class="m-b-20">
                <p className="form-group-title">{messages.formGroup.bank_account}</p>
                <div class="form-group-attached">
                  <FormInput
                    label={messages.bank_name}
                    name="bankName"
                    value={entity.getBankName()}
                    meta={entity.getBankNameMetaInformation()}
                    validation={entity.getBankNameValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.account_holder}
                    name="accountHolder"
                    value={entity.getAccountHolder()}
                    meta={entity.getAccountHolderMetaInformation()}
                    validation={entity.getAccountHolderValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.bank_location}
                    name="bankLocation"
                    value={entity.getBankLocation()}
                    meta={entity.getBankLocationMetaInformation()}
                    validation={entity.getBankLocationValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.iban}
                    name="iban"
                    value={entity.getIban()}
                    meta={entity.getIbanMetaInformation()}
                    validation={entity.getIbanValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.swift_bic}
                    name="swiftBic"
                    value={entity.getSwiftBic()}
                    meta={entity.getSwiftBicMetaInformation()}
                    validation={entity.getSwiftBicValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                </div>
              </div>

              <Button bsStyle="primary" bsSize="lg" block disabled={formStatus.pending} type="submit">
                {formStatus.pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                {messages.send}
              </Button>
            </form>
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
    formStatus: state.formStatus.userEdit,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('userEdit', '/api/users/' + clientId + '.json', args, 'put', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderEnterBankData)
  )
);
